/** Legacy submission-app question keys → dashboard labels (American-style opencalls only). */
export const AMERICAN_STYLE_EXPERIENCE_BRIEF_QUESTION_MAP: Record<
  string,
  string
> = {
  'What is your modeling experience?':
    'Describe your personal style in 2-3 words.',
  'What are your career goals?':
    'Describe the style in your state in 2-3 words.',
  'Why are you interested in this opportunity?':
    'Where do you find inspiration?',
  'Any additional information?':
    'What is your favorite item in your closet? What do you like about it?',
};

export const BIO_CHAR_LIMIT = 150;
export const BIO_EXPAND_BUTTON_TEXT = {
  SHOW_LESS: 'Show less',
  READ_MORE: 'Read more',
};
export const BIO_EXPAND_TEST_ID = 'bio-expand-button';
